export const MAKEUPS_ANNUAL_PERIOD_KEY = "MAKEUPS_ANNUAL_PERIOD";

export const MAKEUPS_ANNUAL_PERIOD_CALENDAR = "calendar";
export const MAKEUPS_ANNUAL_PERIOD_SEASONAL = "seasonal";

export type MakeupsAnnualPeriod =
  | typeof MAKEUPS_ANNUAL_PERIOD_CALENDAR
  | typeof MAKEUPS_ANNUAL_PERIOD_SEASONAL;

export const DEFAULT_MAKEUPS_ANNUAL_PERIOD: MakeupsAnnualPeriod =
  MAKEUPS_ANNUAL_PERIOD_CALENDAR;

export function parseMakeupsAnnualPeriod(
  raw: string | null | undefined,
): MakeupsAnnualPeriod {
  const normalized = String(raw ?? "")
    .trim()
    .toLowerCase();

  if (
    normalized === MAKEUPS_ANNUAL_PERIOD_SEASONAL ||
    normalized === "season" ||
    normalized === "sep_aug" ||
    normalized === "sep-aug"
  ) {
    return MAKEUPS_ANNUAL_PERIOD_SEASONAL;
  }

  return MAKEUPS_ANNUAL_PERIOD_CALENDAR;
}

export function formatMakeupsAnnualPeriodLabel(
  period: MakeupsAnnualPeriod,
): string {
  return period === MAKEUPS_ANNUAL_PERIOD_SEASONAL
    ? "September–August"
    : "January–December";
}

export function formatMakeupsAnnualPeriodShortLabel(
  period: MakeupsAnnualPeriod,
): string {
  return period === MAKEUPS_ANNUAL_PERIOD_SEASONAL ? "Sep–Aug" : "Jan–Dec";
}

export function formatMakeupsAnnualPeriodAdminOptionLabel(
  period: MakeupsAnnualPeriod,
): string {
  return period === MAKEUPS_ANNUAL_PERIOD_SEASONAL
    ? "Seasonal year (September–August)"
    : "Calendar year (January–December)";
}

/** Season start year for Sep–Aug periods. Sep 2025–Aug 2026 => 2025. */
export function getSeasonStartYear(
  date: Date = new Date(),
): number {
  return date.getMonth() >= 8 ? date.getFullYear() : date.getFullYear() - 1;
}

export function formatMakeupsAnnualPeriodRangeLabel(
  period: MakeupsAnnualPeriod,
  referenceDate: Date = new Date(),
): string {
  if (period === MAKEUPS_ANNUAL_PERIOD_SEASONAL) {
    const startYear = getSeasonStartYear(referenceDate);
    return `${startYear}–${startYear + 1}`;
  }
  return String(referenceDate.getFullYear());
}
